// frontend/src/App.jsx
import React, { useState, useEffect } from 'react';
import Login           from './components/auth/Login';
import Dashboard       from './components/dashboard/Dashboard';
import TablaCasas      from './components/houses/TablaCasas';
import PanelPagos      from './components/pagos/PanelPagos';
import PanelGastos     from './components/gastos/PanelGastos';
import PanelTarifas    from './components/config/PanelTarifas';
import PanelImportacion from './components/import/PanelImportacion';
import PanelLog        from './components/admin/PanelLog';

const TABS = [
  { id:'dashboard',   label:'📊 Dashboard',      componente:Dashboard },
  { id:'casas',       label:'🏘️ Casas',          componente:TablaCasas },
  { id:'pagos',       label:'💳 Pagos',           componente:PanelPagos },
  { id:'gastos',      label:'💸 Gastos',          componente:PanelGastos },
  { id:'tarifas',     label:'🗺️ Tarifas',         componente:PanelTarifas },
  { id:'importacion', label:'⚙️ Configuración',    componente:PanelImportacion },
  { id:'log',         label:'🕵️ Actividad',       componente:PanelLog, soloAdmin:true },
];

export default function App() {
  const [usuario,   setUsuario]   = useState(null);
  const [token,     setToken]     = useState(null);
  const [tabActiva, setTabActiva] = useState('dashboard');

  // Restaurar sesión al recargar
  useEffect(() => {
    const t = localStorage.getItem('calleb_token');
    const u = localStorage.getItem('calleb_usuario');
    if (t && u) { setToken(t); setUsuario(JSON.parse(u)); }
  }, []);

  const handleLogin = (u, t) => { setUsuario(u); setToken(t); };

  const handleLogout = () => {
    localStorage.removeItem('calleb_token');
    localStorage.removeItem('calleb_usuario');
    setUsuario(null); setToken(null);
  };

  if (!usuario) return <Login onLogin={handleLogin}/>;

  const tabsVisibles = TABS.filter(t => !t.soloAdmin || usuario.rol === 'admin');
  const TabComp = tabsVisibles.find(t => t.id === tabActiva)?.componente || Dashboard;

  return (
    <div style={{ fontFamily:"'Inter','Segoe UI',sans-serif",
                  background:'#f0f4f8', minHeight:'100vh' }}>
      <header style={{
        background:'#1a3a5c', padding:'0 20px',
        display:'flex', alignItems:'center', gap:20,
        boxShadow:'0 2px 8px rgba(0,0,0,.2)',
        position:'sticky', top:0, zIndex:100,
      }}>
        <div style={{ padding:'12px 0', flexShrink:0 }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#fff' }}>🏠 Calle B</div>
          <div style={{ fontSize:9, color:'#93c5fd', letterSpacing:'1px',
                        textTransform:'uppercase' }}>Condominio</div>
        </div>

        <nav style={{ display:'flex', gap:0, overflowX:'auto', flex:1 }}>
          {tabsVisibles.map(tab => (
            <button key={tab.id} onClick={() => setTabActiva(tab.id)} style={{
              background:   tabActiva===tab.id ? 'rgba(255,255,255,.15)' : 'transparent',
              color:        tabActiva===tab.id ? '#fff' : '#93c5fd',
              border:       'none',
              borderBottom: tabActiva===tab.id ? '2px solid #60a5fa' : '2px solid transparent',
              padding:      '16px 12px 14px', fontSize:12,
              fontWeight:   tabActiva===tab.id ? 600 : 400,
              cursor:'pointer', whiteSpace:'nowrap', transition:'all .15s',
            }}>
              {tab.label}
            </button>
          ))}
        </nav>

        {/* Usuario y logout */}
        <div style={{ display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:12, fontWeight:600, color:'#fff' }}>{usuario.nombre}</div>
            <div style={{ fontSize:10, color:'#93c5fd', textTransform:'uppercase' }}>
              {usuario.rol}
            </div>
          </div>
          <button onClick={handleLogout} style={{
            background:'rgba(255,255,255,.1)', color:'#fff', border:'1px solid rgba(255,255,255,.2)',
            borderRadius:8, padding:'6px 12px', fontSize:11, cursor:'pointer',
          }}>
            Salir
          </button>
        </div>
      </header>

      <main style={{ maxWidth:1400, margin:'0 auto' }}>
        <TabComp token={token} usuario={usuario}/>
      </main>
    </div>
  );
}
